import { Table } from "antd";
import { IoTrashBinOutline } from "react-icons/io5";
import { FiEdit } from "react-icons/fi";
import Manage from "..";
import { useEffect, useState } from "react";
import UpdateFirm from "./components/UpdateFirm";
import DeleteFirm from "./components/DeleteFirm";
import CreateWrapper from "./components/CreateWrapper";
import fetchDataTrace from "../../../services/fetchDataTrace";

export default function AllFirms() {
  const [updateModal, setUpdateModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selected, setSelected] = useState({});
  const [firms, setFirms] = useState([]);
  const [isLoading, setLoading] = useState(false);

  const handleFetchFirms = async () => {
    setLoading(true);
    const uri = `firms`;
    const data = await fetchDataTrace({ uri });
    setLoading(false);
    setFirms(data?.payload);
  };

  useEffect(() => {
    handleFetchFirms();
  }, []);

  const columns = [
    {
      title: "S/N",
      width: 40,
      render: (record: any, text: any, index: any) => (
        <span className="text-gray-700 ml-2">{index + 1}</span>
      ),
    },
    {
      title: "Name",
      width: 200,
      render: (record: any) => (
        <div className="text-gray-700 w-48">
          {record?.name === null ? "-" : record?.name}
        </div>
      ),
    },
    {
      title: "Address 1",
      width: 100,
      render: (record: any) => (
        <div className="text-gray-700 truncate w-36">
          {record?.address1 === null ? "-" : record?.address1}
        </div>
      ),
    },
    {
      title: "Address 2",
      width: 100,
      render: (record: any) => (
        <div className="text-gray-700 truncate w-36">
          {record?.address2 === null ? "-" : record?.address2}
        </div>
      ),
    },
    {
      title: "Address 3",
      width: 100,
      render: (record: any) => (
        <div className="text-gray-700 truncate w-36">
          {record?.address3 === null ? "-" : record?.address3}
        </div>
      ),
    },
    {
      title: "Address 4",
      width: 100,
      render: (record: any) => (
        <div className="text-gray-700 truncate w-36">
          {record?.address4 === null ? "-" : record?.address4}
        </div>
      ),
    },
    {
      title: "Website",
      width: 120,
      render: (record: any) => (
        <div className="text-gray-700 truncate w-36">
          {record?.website === null ? "-" : record?.website}
        </div>
      ),
    },

    {
      title: "Code",
      width: 50,
      render: (record: any) => (
        <div className="text-gray-700 w-10">
          {record?.code === null ? "-" : record?.code}
        </div>
      ),
    },
    {
      title: "Logo",
      width: 50,
      render: (record: any) => (
        <div className="border p-1">
          <img src={record?.logo} />
        </div>
      ),
    },
    {
      title: "Active",
      width: 50,
      render: (record: any) => (
        <div className="text-gray-700">
          {record?.isActive ? (
            <div className="text-green-500">Yes</div>
          ) : (
            <div className="text-red-500">No</div>
          )}
        </div>
      ),
    },
    {
      title: "Action",
      width: 40,
      render: (record: any) => (
        <div className="flex">
          <button
            onClick={() => {
              setSelected({
                ...record,
              });
              setUpdateModal(true);
            }}
            className="flex justify-center items-center text-gray-700 border rounded-md p-2 bg-gray-100 hover:bg-gray-200 cursor-pointer"
          >
            <FiEdit />
          </button>
          <button
            onClick={() => {
              setSelected({
                ...record,
              });
              setDeleteModal(true);
            }}
            className="flex justify-center items-center ml-1 text-gray-700 border rounded-md p-2 bg-red-100 hover:bg-red-200 cursor-pointer"
          >
            <IoTrashBinOutline />
          </button>
        </div>
      ),
    },
  ];

  return (
    <Manage
      title={"KJL Group Companies"}
      subtitle={"All"}
      description={"List of all companies"}
      actions={<CreateWrapper refetch={handleFetchFirms} />}
    >
      <div className="">
        <Table
          size="small"
          dataSource={firms}
          loading={isLoading}
          columns={columns}
        />

        <UpdateFirm
          selected={selected}
          isVisible={updateModal}
          setVisible={setUpdateModal}
          refetch={handleFetchFirms}
        />

        <DeleteFirm
          selected={selected}
          isVisible={deleteModal}
          setDeleteModal={setDeleteModal}
        />
      </div>
    </Manage>
  );
}
